import { memo, PropsWithChildren, useRef } from 'react'
import { ParallaxProvider } from 'react-scroll-parallax'

import { ParallaxContainerProps } from './ParallaxContainer.types'

const ParallaxContainer = ({
  children,
  ...rest
}: PropsWithChildren<ParallaxContainerProps>) => {
  const ref = useRef<HTMLDivElement>(null)

  return (
    <ParallaxProvider scrollContainer={ref.current ?? undefined} {...rest}>
      {children}
    </ParallaxProvider>
  )
}

export default memo(ParallaxContainer)
